import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi } from "../lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("bcp_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await adminApi.get("/admin/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("bcp_admin_token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/auth/login", { email, password });
    localStorage.setItem("bcp_admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await adminApi.post("/admin/auth/logout"); } catch { }
    localStorage.removeItem("bcp_admin_token");
    setAdmin(null);
  };

  // Returns true if the logged-in admin has the given permission.
  // Super admin with ["*"] always returns true for everything.
  const hasPermission = (perm) => {
    if (!admin) return false;
    const perms = admin.permissions || [];
    if (perms.includes("*")) return true;
    return perms.includes(perm);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, hasPermission }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);